.overlay {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 5;
}

.top {
  position: absolute;
  top: 12px;
  left: 56px;
  right: 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  pointer-events: auto;
}

.badge {
  background: linear-gradient(135deg, #e11d2e, #ff4d5a);
  color: #fff;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.08em;
  padding: 4px 8px;
  border-radius: 6px;
  text-transform: uppercase;
  box-shadow: 0 4px 14px rgba(225, 29, 46, 0.35);
}

.title {
  border: 0;
  background: rgba(12, 14, 18, 0.72);
  backdrop-filter: blur(10px);
  color: #fff;
  font-size: 13px;
  padding: 7px 12px;
  border-radius: 10px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  max-width: min(420px, 60vw);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.learn {
  color: #7ec8ff;
  font-weight: 600;
}

.countdown {
  margin-left: auto;
  color: #fff;
  font-size: 12px;
  background: rgba(12, 14, 18, 0.72);
  backdrop-filter: blur(10px);
  padding: 6px 10px;
  border-radius: 10px;
  font-variant-numeric: tabular-nums;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.skipWrap {
  position: absolute;
  right: 14px;
  bottom: 78px;
  pointer-events: auto;
}

.skip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 0;
  background: rgba(14, 16, 20, 0.92);
  backdrop-filter: blur(12px);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  padding: 11px 16px;
  border-radius: 12px;
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 0.12);
  transition: background 0.15s ease, transform 0.15s ease;
}

.skip:hover {
  background: rgba(30, 34, 40, 0.96);
  transform: translateY(-1px);
}

.skipLocked {
  background: rgba(14, 16, 20, 0.85);
  color: #c5c9d1;
  font-size: 13px;
  padding: 11px 16px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
}
